module.exports = __webpack_public_path__ + "static/chisel1-641f8cd4d2db921966739eeb982dfa5e.svg";